import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import useCustomNavigate from "../../components/customNavigationHook";

import { menuItems } from "../../config/sideMenuList";
const SideMenu = ({
  menuSideBarVisible,
  setMenuSideBarVisible,
  activeSideTab,
}) => {
  const navigate = useCustomNavigate();
  const [openKeys, setOpenKeys] = useState(menuItems.map((i) => i.key));
  const [sideMenuItems, setSideMenuItems] = useState([]);

  const filterMenuItems = (menuItems, allowedRoles) => {
    const filteredItems = menuItems.reduce((acc, item) => {
      if (
        !item.role ||
        item.role.length === 0 ||
        item.role.some((role) => allowedRoles.includes(role))
      ) {
        const newItem = { ...item };
        if (item.children) {
          newItem.children = filterMenuItems(item.children, allowedRoles);
        }
        acc.push(newItem);
      }
      return acc;
    }, []);
    return filteredItems;
  };

  useEffect(() => {
    const setMenu = () => {
      const userRole = JSON.parse(localStorage.getItem("userinfo")).roles;
      let filteredMenuItems = filterMenuItems(
        [...activeSideTab.children],
        userRole
      );

      setSideMenuItems(filteredMenuItems);
    };
    setMenu();
  }, [activeSideTab]);

  const onClick = ({ key }) => {
    const menuItem = findMenuItem(sideMenuItems, key);
    if (menuItem && menuItem.route) {
      // Check if the route is an external URL
      if (
        menuItem.route.startsWith("http://") ||
        menuItem.route.startsWith("https://")
      ) {
        // Open external URL in a new tab
        window.open(menuItem.route, "_blank");
      } else {
        // Use internal navigation for relative routes
        navigate(menuItem.route);
      }
    }
    // setSelectedKeys([key]);
    setMenuSideBarVisible(false);
  };

  const findMenuItem = (items, key) => {
    for (const item of items) {
      if (item.key === key) return item;
      if (item.children) {
        const found = findMenuItem(item.children, key);
        if (found) return found;
      }
    }
    return null;
  };

  return (
    <div
      className={`side-menu-dropdown ${
        menuSideBarVisible ? "" : "side-menu-hidden"
      }`}
    >
      <p style={{ fontSize: "16px", fontWeight: "600", paddingLeft: "14px" }}>
        {activeSideTab?.label}
      </p>
      <Menu
        onOpenChange={(keys) => setOpenKeys(keys)}
        mode="inline"
        style={{ width: "100%", backgroundColor: "transparent" }}
        items={sideMenuItems}
        onClick={onClick}
        defaultOpenKeys={openKeys}
      />
    </div>
  );
};

export default SideMenu;
